import React from 'react';

// Colores para los estados de la cita
const estadoColors = {
  pendiente: 'bg-yellow-400',
  confirmada: 'bg-blue-500',
  completada: 'bg-green-500',
  cancelada: 'bg-red-400',
  no_asiste: 'bg-purple-500',  
};

const AppointmentBlock = ({ cita, paciente, hora, motivo }) => {
  const color = estadoColors[cita.estado] || 'bg-gray-400';  // Usamos el color del estado, si no está, usamos un color predeterminado

  return (
    <div
      className={`rounded-md px-2 py-1 text-xs font-semibold text-white shadow-sm cursor-pointer ${color} truncate`}
      title={`${paciente || 'Paciente'} - ${cita.hora} | ${motivo || ''}`}
    >
      <div className="truncate">{paciente || 'Paciente'}</div>
      <div className="text-[10px] font-normal">{hora}</div>
      <div className="text-[10px] font-normal mt-1">{motivo || 'Sin motivo'}</div> {/* Motivo debajo de la hora */}
    </div>
  );
};

export default AppointmentBlock;
